import React, { useState, useEffect } from 'react';
import { getUserInvitationsByLocalId } from '../../../../../../crud/users_api/user_invitations';
import TableUserInvitations from './components/TableUserInvitations/TableUserInvitations';
import MiniLoadingSpinner from '../../../../../../components/Spinners/MiniLoadingSpinner';
import FilterBar from './components/FilterBar/FilterBar';

interface FilterOption {
  value: string | number;
  label: string;
}

const InvitacionesView: React.FC = () => {
  const [invitations, setInvitations] = useState<any[]>([]);
  const [filteredInvitations, setFilteredInvitations] = useState<any[]>([]);
  const [originalInvitations, setOriginalInvitations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  
  // Filter states
  const [selectedPuesto, setSelectedPuesto] = useState<FilterOption[]>([]);
  const [selectedEstado, setSelectedEstado] = useState<FilterOption[]>([]);
  const [showInvitationModal, setShowInvitationModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    fetchInvitations();
  }, []);

  useEffect(() => {
    let filtered = [...invitations];

    // Filter by puesto
    if (selectedPuesto.length > 0) {
      filtered = filtered.filter(inv => 
        selectedPuesto.some(p => p.label === inv.puesto_name)
      );
    }

    // Filter by estado (valid/invalid)
    if (selectedEstado.length > 0) {
      filtered = filtered.filter(inv => 
        selectedEstado.some(e => 
          (e.value === 1 && inv.valid) || (e.value === 0 && !inv.valid)
        )
      );
    }

    // Apply search filter
    if (searchValue.trim()) {
      const q = searchValue.toLowerCase();
      filtered = filtered.filter(inv =>
        `${inv.nombre || ''} ${inv.invitation_code || ''} ${inv.puesto_name || ''}`.toLowerCase().includes(q)
      );
    }

    setFilteredInvitations(filtered);
  }, [selectedPuesto, selectedEstado, invitations, searchValue]);

  const fetchInvitations = async () => {
    try {
      setLoading(true);
      const userContext = localStorage.getItem('user');
      const localId = userContext ? JSON.parse(userContext).local_id : 0;
      const response = await getUserInvitationsByLocalId(localId);
      setInvitations(response.data);
      setFilteredInvitations(response.data);
      setOriginalInvitations(response.data);
    } catch (error) {
      console.error("Error fetching invitations:", error);
    } finally {
      setLoading(false);
    }
  };

  // Get unique puestos from invitations
  const getPuestosOptions = (): FilterOption[] => {
    const uniquePuestos = Array.from(new Set(invitations.map(inv => inv.puesto_name)))
      .filter(name => name);
    return uniquePuestos.map((name, index) => ({
      value: index,
      label: name
    }));
  };

  // Estado options
  const estadoOptions: FilterOption[] = [
    { value: 1, label: 'Válido' },
    { value: 0, label: 'Inválido' }
  ];

  if (loading) return <MiniLoadingSpinner />;

  return (
    <>
      {/* Filter Bar with integrated search */}
      <FilterBar
        puestosOptions={getPuestosOptions()}
        selectedPuesto={selectedPuesto}
        selectedEstado={selectedEstado}
        onPuestoChange={setSelectedPuesto}
        onEstadoChange={setSelectedEstado}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onCreateInvitation={() => setShowInvitationModal(true)}
      />

      {/* Invitations Table */}
      <TableUserInvitations 
        data={filteredInvitations}
        setData={(newData: any[]) => {
          setInvitations(newData);
          setFilteredInvitations(newData);
          setOriginalInvitations(newData);
        }}
        hasPermission={true} 
        OriginalInvitations={originalInvitations} 
        setOriginalInvitations={setOriginalInvitations}
        showInvitationModal={showInvitationModal}
        setShowInvitationModal={setShowInvitationModal}
      />
    </>
  );
};

export default InvitacionesView;
